// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3FiOU","alertIcon":"ConfirmModal_alertIcon__23p3_"};